/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentErrorMessageActionContentMarginTop = "1.5rem";
export const componentErrorMessageContainerAlignHorizontal = "center";
export const componentErrorMessageMediaMarginBottom = "2rem";
export const componentErrorMessageTextLabelAliasName = "component.text.body";
export const componentErrorMessageTextLabelAliasOptionsSize = "medium";
export const componentErrorMessageTextLabelTextColor = "#74767c";
export const componentErrorMessageTitleAliasName = "component.text.heading";
export const componentErrorMessageTitleAliasOptionsSize = "large";
export const componentErrorMessageTitleAliasOptionsWeight = 700;
export const componentErrorMessageTitleMarginBottom = "0.5rem";